import { render, staticRenderFns } from "./StaffMemberWithAvailabilityChip.vue?vue&type=template&id=d661346e&"
import script from "./StaffMemberWithAvailabilityChip.vue?vue&type=script&lang=ts&"
export * from "./StaffMemberWithAvailabilityChip.vue?vue&type=script&lang=ts&"
import style0 from "./StaffMemberWithAvailabilityChip.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
installComponents(component, {VBadge})
